import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal} from 'antd'

@inject('store') @observer
class LogoutModal extends Component {
  handleOk = () => {
    this.props.store.auth.logout()
  }
  render() {
    return(
      <Modal
        title='Log Out'
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.close}
      >
        <h4>Are you sure you want to log out?</h4>
      </Modal>
    )
  }
}

export default LogoutModal
